export default __webpack_public_path__ + "static/media/purifiedsweetpressedhaste.85cad59a.jpg";